import ExcelSvgIcon from "./excel.svg";
function ExcelIcon() {
  return <img className="excel-img" src={ExcelSvgIcon} alt="excel-svg" />;
}

export default ExcelIcon;
